import { createSelector } from "reselect"

const getBreadcrumbs = (
    state: ResourceHeader.Header,
): Record<string, ResourceHeader.BreadcrumbInfo> => state.breadcrumbs

export interface SortedBreadcrumbs {
    sortedBreadcrumbs: ResourceHeader.BreadcrumbInfo[]
}

export const getSortedBreadcrumbs = createSelector(
    [getBreadcrumbs],
    (breadcrumbs): ResourceHeader.BreadcrumbInfo[] =>
        Object.values(breadcrumbs).sort((a, b) => a.index - b.index),
)

const getButtons = (
    state: ResourceHeader.Header,
): Record<string, ContextMenu.Button> => state.buttons

export interface SeparatedButtons {
    optionalCustomButtons: Record<string, ContextMenu.Button>
    optionalStandardButtons: Record<string, ContextMenu.Button>
    visibleCustomButtons: Record<string, ContextMenu.Button>
    visibleStandardButtons: Record<string, ContextMenu.Button>
}

export const getSeparatedButtonsByVisibility = createSelector(
    [getButtons],
    (buttons): SeparatedButtons => {
        const optionalCustomButtons: Record<string, ContextMenu.Button> = {}
        const optionalStandardButtons: Record<string, ContextMenu.Button> = {}
        const visibleCustomButtons: Record<string, ContextMenu.Button> = {}
        const visibleStandardButtons: Record<string, ContextMenu.Button> = {}

        for (const key in buttons) {
            const button = buttons[key]

            if (button.inOptionalMenu) {
                if (button.isCustom) {
                    optionalCustomButtons[button.uuid] = button
                } else {
                    optionalStandardButtons[button.uuid] = button
                }
            } else if (button.isCustom) {
                visibleCustomButtons[button.uuid] = button
            } else {
                visibleStandardButtons[button.uuid] = button
            }
        }

        return {
            optionalCustomButtons,
            optionalStandardButtons,
            visibleCustomButtons,
            visibleStandardButtons,
        }
    },
)
